import React from "react";
import { MENUS } from "../../../../../utils/ui.constants";
import SidebarList from "./SidebarList";
import { Box, Divider } from "@mui/material";
import { useSelector } from "react-redux";
import { allowShowAuthorize } from "../../../../../utils/helpers";

function SidebarWide() {
  const { profile, rights } = useSelector((state: any) => state.auth);
  return (
    <>
      {MENUS.map((menu, index) => {
        const show =
          menu.show ||
          profile?.admin_app ||
          allowShowAuthorize({
            module: menu.items
              ? menu.items.map((item) => item.module)
              : menu.module || "",
            rights,
          });
        if (!show) return null;
        return (
          <React.Fragment key={index}>
            <SidebarList subheaderText={menu.subheader} items={menu.items} />
            {index < MENUS.length - 1 && (
              <Box sx={{ px: 2 }}>
                <Divider />
              </Box>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
}

export default SidebarWide;
